import { create } from "zustand";

export const useResultStore = create((set) => ({
   isActiveMenu: "",
   activeResult: [],
   // Whether the Results page currently has the Expert Insights tab open. Set by
   // the Results page and read by the assessment aside, which uses it to hide self
   // assessments (Expert Insights only applies to guided assessments).
   isExpertInsightsActive: false,

   setActiveItem: (item) => {
      set({
         isActiveMenu: item
      });
   },

   setIsExpertInsightsActive: (payload) => {
      set({
         isExpertInsightsActive: payload
      });
   },

   setActiveResult: (payload) => {
      set({
         activeResult: payload
      });
   },

   fullNameChanged: false,
   setFullNameChanged: (payload) => {
      set({
         fullNameChanged: payload
      });
   }
}));
